import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory, useLocation } from "react-router-dom";
import { Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const HIDDEN_PATHS = ["/lobby", "/profile", "/admin"];

export default function ProfileIndicator() {
  const { isAuthenticated, user } = useAuth0();
  const history = useHistory();
  const location = useLocation();

  if (!isAuthenticated || HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) {
    return null;
  }

  return (
    <Chip
      icon={<PersonIcon />}
      label={user?.nickname ?? "Profile"}
      onClick={() => history.push("/profile")}
      sx={{
        position: "fixed",
        top: 12,
        right: 12,
        zIndex: 1300,
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(255,255,255,0.7)",
        fontWeight: 600,
        cursor: "pointer",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
      }}
    />
  );
}
